<template>
    <div>
        <h1 class="text-2xl font-medium mb-4"> Add a Manager </h1>
        <div class="flex flex-col space-y-4 w-full sm:w-1/2 lg:w-4/12">
            <div>
                <label> is KAM (Key Account Manager) </label>
                <vs-switch v-model="isKAM" />
            </div>
            <div>
                <label> Account Mananger Name </label>
                <vs-input :success="!errors.first('name')" :danger="errors.first('name') ? true : false"
                    :danger-text="errors.first('name')" data-vv-scope="info" val-icon-success="done"
                    val-icon-danger="error" data-vv-as="name" name="name" class="w-full" v-model="name"
                    v-validate="'required'" />
            </div>
            <div>
                <label> Phone Number </label>
                <vs-input :success="!errors.first('phone')" :danger="errors.first('phone') ? true : false"
                    :danger-text="errors.first('phone')" data-vv-scope="info" val-icon-success="done"
                    val-icon-danger="error" data-vv-as="phone" name="phone" class="w-full" v-model="phone"
                    />
            </div>
            <div>
                <label> Email </label>
                <vs-input :success="!errors.first('email')" :danger="errors.first('email') ? true : false"
                    :danger-text="errors.first('email')" data-vv-scope="info" val-icon-success="done"
                    val-icon-danger="error" data-vv-as="email" name="email" class="w-full" v-model="email"
                    v-validate="'required'" />
            </div>
        </div>
        <vs-button :disabled="!validateForm" type="filled" @click="save" class="px-6 mt-2">Add Manager</vs-button>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: 'AddAccountManager',
    components: {},
    data() {
        return {
            name: '',
            isKAM: false,
            phone: null,
            email: null,
        };
    },
    computed: {
        validateForm() {
            return !this.errors.any();
        },
    },
    methods: {
        ...mapActions('appUser', ['saveAccountManagerDetails']),

        async save() {
            let isValid = await this.$validator.validateAll('info');

            if (isValid) {
                const data = {
                    name: this.name,
                    isKAM: this.isKAM,
                    phone: this.phone,
                    email: this.email,
                };
                this.$vs.loading();
                this.saveAccountManagerDetails(data)
                    .then((result) => {
                        if(result.message === 'Success') {
                            this.$vs.notify({
                                title: 'Success',
                                text: 'Account manager created successfully.',
                                color: 'success',
                            });
                            this.$router.back();
                        } else {
                            this.$vs.notify({
                                title: 'Error',
                                text: result.message,
                                color: 'danger',
                            });
                        }
                    })
                    .catch((err) => {
                        this.$vs.notify({
                            title: 'Error',
                            text: err.data.message,
                            color: 'danger',
                        });
                    })
                    .finally(() => {
                        this.$vs.loading.close();
                    });
        }},
    },
};
</script>